export default __webpack_public_path__ + "static/media/image_by_url.92fa673f.png";